/** @format */

import { BrandContext } from "./BrandContext";
import React, { useMemo, useState } from "react";
import { getBrandFromHostname, type Brand } from "@question-bank/shared";

export const BrandProvider = ({ children }: { children: React.ReactNode }) => {
	// Brand is determined by the host the app is reached on (e.g.
	// `*.resources.eduqas.co.uk` -> eduqas), not by the signed-in user.
	const [brand, setBrand] = useState<Brand>(() => getBrandFromHostname(globalThis.location.hostname));
	const value = useMemo(() => ({ brand, setBrand }), [brand]);
	return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
};
